module.exports = __webpack_public_path__ + "img/Button-kosik-2021-03.6b7cc6ba.png";